import {
  TileButtonsContainer,
  TileMuteButton,
  TilePlayButton,
} from "@/components/ui-v2";

interface VideoPreviewTileControlsProps {
  isPlaying: boolean;
  isMuted: boolean;
  disabledMuteButton: boolean;
  onAction: (
    event: React.MouseEvent,
    action: "TOGGLE_MUTE" | "TOGGLE_PLAY",
  ) => void;
}

export const VideoPreviewTileControls = (
  props: VideoPreviewTileControlsProps,
) => {
  const { isPlaying, isMuted, disabledMuteButton, onAction } = props;

  return (
    <TileButtonsContainer>
      <TileMuteButton
        isMuted={isMuted}
        onAction={onAction}
        disabled={disabledMuteButton}
      />
      <TilePlayButton isPlaying={isPlaying} onAction={onAction} />
    </TileButtonsContainer>
  );
};
